import React from "react";
import { Text } from "../../../components/controls/Text";
import { Email } from "../../../components/controls/Email";
import { Password } from "../../../components/controls/Password";
import { Phone } from "../../../components/controls/Phone";
import { useSelector } from "../../../hooks";
import { useIntl } from "react-intl";
import { useFormContext } from "react-hook-form";
import { LoginLink } from "../../../components/common/LoginLink";

interface CompanyContactProps {
	onChange: (event: any) => void;
}

export const CompanyContact = (props: CompanyContactProps) => {
	const { formatMessage } = useIntl();

	const name = useSelector((state) => state.registration.b2b.form.name);
	const phone = useSelector((state) => state.registration.b2b.form.phone);
	const email = useSelector((state) => state.registration.b2b.form.email);
	const password = useSelector((state) => state.registration.b2b.form.password);
	const invoiceEmail = useSelector(
		(state) => state.registration.b2b.form.invoiceEmail,
	);
	const areaCode = useSelector((state) => state.settings.areaCode);

	const validationRules = useSelector(
		(state) => state.settings.validationRules,
	);

	const {
		register,
		formState: { errors },
	} = useFormContext();

	return (
		<>
			<Text
				id="name"
				className="form-input"
				ref={register("name", { value: name })?.ref}
				error={
					typeof errors.name?.message === "string"
						? errors.name.message
						: undefined
				}
				label={formatMessage({ id: "komid.register.name" })}
				onChange={(event) => {
					props.onChange(event);
				}}
				onBlur={(event) => {
					if (name !== event.target.value) {
						props.onChange(event);
					}
				}}
				autoComplete="name"
			/>

			<Email
				id="email"
				className="form-input"
				ref={register("email", { value: email })?.ref}
				error={
					typeof errors.email?.message === "string"
						? errors.email.message
						: undefined
				}
				loginLink={errors.email?.message && <LoginLink form="b2b" />}
				value={email}
				autoComplete="new-password"
				autoFocus={false}
				label={formatMessage({ id: "komid.register.email" })}
				placeholder={formatMessage({
					id: "komid.register.email.placeholder",
				})}
				onChange={(event) => {
					props.onChange(event);
				}}
				onBlur={(event) => {
					if (email !== event.target.value) {
						props.onChange(event);
					}
				}}
			/>

			<Password
				id="password"
				ref={register("password", { value: password })?.ref}
				error={
					typeof errors.password?.message === "string"
						? errors.password.message
						: undefined
				}
				className="form-input"
				label={formatMessage({
					id: "komid.register.password",
				})}
				onChange={(event) => {
					props.onChange(event);
				}}
				onBlur={(event) => {
					if (password !== event.target.value) {
						props.onChange(event);
					}
				}}
				placeholder="******"
				maxLength={50}
				autoComplete="new-password"
			/>

			<Phone
				id="phone"
				className="form-input"
				ref={register("phone", { value: phone })?.ref}
				error={
					typeof errors.phone?.message === "string"
						? errors.phone.message
						: undefined
				}
				value={phone}
				placeholder={formatMessage({
					id: "komid.register.mobilephone.placeholder",
				})}
				maxLength={parseInt(validationRules.mobilePhoneLength, 10)}
				label={formatMessage({
					id: "komid.register.mobilephone",
				})}
				autoComplete="tel-national"
				areaCode={areaCode}
				onChange={(event) => {
					props.onChange(event);
				}}
				onBlur={(event) => {
					if (phone !== event.target.value) {
						props.onChange(event);
					}
				}}
			/>

			<Email
				id="invoiceEmail"
				className="form-input"
				ref={register("invoiceEmail", { value: invoiceEmail })?.ref}
				error={
					typeof errors.invoiceEmail?.message === "string"
						? errors.invoiceEmail.message
						: undefined
				}
				value={invoiceEmail}
				autoComplete="new-password"
				autoFocus={false}
				tooltip={formatMessage({ id: "komid.register.invoice.email.tooltip" })}
				label={formatMessage({
					id: "komid.register.invoice.email",
				})}
				placeholder={formatMessage({
					id: "komid.register.email.placeholder",
				})}
				onChange={(event) => {
					props.onChange(event);
				}}
				onBlur={(event) => {
					if (invoiceEmail !== event.target.value) {
						props.onChange(event);
					}
				}}
			/>
		</>
	);
};
